import { Button, Input, NativeSelect, Tooltip } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import SendIcon from '@material-ui/icons/Send';
import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import ptBR from 'date-fns/locale/pt-BR';
import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import DatePicker, { registerLocale } from 'react-datepicker';
import StarIcon from '@material-ui/icons/Star';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EmailIcon from '@mui/icons-material/Email';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import NoteIcon from '@mui/icons-material/Note';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ChatBotIcon from '@mui/icons-material/MarkUnreadChatAltOutlined';
import { ConfirmationBox } from '../../../components/ConfirmationBox';
import Loading from '../../../components/Loading';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import colors from '../../../styles/settings/colors';
import { convertForRealFormatted } from '../../../utils/convertForRealFormatted';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { capitalizeFirstLetter } from '../../../utils/functions';
import ScheduledTable from './ScheduledTable';
import * as S from './styles';
import { useInterestingEmails } from './useInterestingEmails';

registerLocale('ptBR', ptBR);

const normalizeSearchText = (value = '') =>
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();

const NO_DATA_MESSAGE =
  'Sucessso na execução da solicitação, porém, não existe retorno com os parâmetro(s) solicitado(s).';

function AnticipationMiddleContent({
  anchorId,
  reloadPage,
  updateRightTable,
  updateInfo,
  setUpdateInfo,
  setOpcoesButtons,
  opcoesButtons,
  reloadRightTable,
  setReloadRightTable,
  isLoading,
  setIsLoading,
  selectedAnchor,
  isTimer,
  agendamentosBackground
}) {
  const {
    confirmationBox,
    emailsData,
    fetchEmails,
    handleCheckEmail,
    handleConfirmationBox,
    isSending,
    setConfirmationBox,
  } = useInterestingEmails();
  const { setMessageData } = useMessageBox();
  const [primaryOption, setPrimaryOption] = useState('notas-disponiveis');
  const [secondOptionButton, setSecondOptionButton] = useState('Agendado');
  const [providers, setProviders] = useState([]);
  const [fornecedorSearchText, setFornecedorSearchText] = useState('');
  const [destinoOpcoes, setDestinoOpcoes] = useState([]);
  const [proposesSearchResult, setProposesSearchResult] = useState([]);
  const [proposesSearch, setProposesSearch] = useState({
    dataInicial: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    dataFinal: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    razaoSocial: '',
    cnpjCpf: '',
    fornecedorId: '',
    status: '',
    destinoPagamentoId: "0",
  });

  const [scheduleSearchResult, setScheduleSearchResult] = useState([]);
  const [schedulesSearch, setSchedulesSearch] = useState({
    dataInicial: new Date(),
    dataFinal: new Date(),
    razaoSocial: '',
    cnpjCpf: '',
    fornecedorId: '',
  });

  const [pesquisarSearch, setPesquisarSearch] = useState({
    razaoSocial: '',
    cnpjCpf: '',
  })

  const renderFornecedorHeader = () => (
    <div className="fornecedor-header-with-filter">
      <span>Fornecedor</span>
      <div className="filter text-filter">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar fornecedor"
          value={fornecedorSearchText}
          onChange={(e) => setFornecedorSearchText(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );

  const columnsAgendado = [
    {
      text: '',
      dataField: 'origem',
      sort: true,
      formatter: (cell) => {
        switch (cell) {
          case 'NotasDisponiveis':
            return <NoteIcon style={{ color: '#a349a3', fontSize: '18px' }} />
          case 'Classificados':
            return <FilterAltIcon color="action" style={{ color: '#ff0000', fontSize: '20px' }} />
          case 'Agendamento':
            return <CalendarMonthIcon style={{ color: '#1976d2', fontSize: '18px' }} />
          case 'Favoritos':
            return <StarIcon style={{ color: '#f0a918', fontSize: '20px'}} />
          case 'EmailInteresse':
            return <EmailOutlined  style={{ color: '#000000', fontSize: '20px' }}/>
          case 'EmailInteresseAprovado':
            return <EmailIcon  style={{ color: '#689f38', fontSize: '20px' }}/>
          case 'EmailInteresseRecusado':
            return <EmailIcon style={{ color: '#ff0000', fontSize: '20px' }}/>
          case 'ChatBot':
            return <ChatBotIcon style={{ color: '#689f38', fontSize: '20px' }}/>
          default:
            return ''
        }
      }
    },
    {
      text: 'Fornecedor',
      dataField: 'fornecedor',
      sort: true,
      headerFormatter: renderFornecedorHeader,
      formatter: (cell, row) => {
        return (
          <Tooltip placement="top" title={cell}>
            <span
              onClick={() => {
                reloadPage(row, 'NotasDisponiveis');
                setUpdateInfo({
                  origin: primaryOption,
                  fornecedorId: row?.fornecedorId,
                  canUpdate: false,
                });
              }}
            >
              {cell && cell.length >= 45 ? `${cell.slice(0, 45)}...` : cell}
            </span>
          </Tooltip>
        );
      },
    },
    {
      text: 'Prz',
      dataField: 'prazoMedio',
      className: 'text-right',
      sort: true,
      formatter: (cell) => {
        return <span className="text-right d-block">{cell}</span>;
      },
    },
    {
      text: 'Valor',
      dataField: 'valorBruto',
      sort: true,
      formatter: (cell) => {
        return (
          <span className="text-right d-block">{cell && convertForRealFormatted(cell, 2)}</span>
        );
      },
    },
    {
      text: 'Simulação',
      dataField: 'simulacao',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const distantFuture = new Date(8640000000000000);
        const dateA = a ? new Date(a) : distantFuture;
        const dateB = b ? new Date(b) : distantFuture;

        if (order === 'desc') {
          return dateB - dateA;
        }
        return dateA - dateB;
      },
      formatter: (cell) => {
        return (
          <span className="text-center-block">
            {cell && format(new Date(cell), 'dd/MM/yy HH:mm')}
          </span>
        );
      },
    },
    {
      text: 'Interesse',
      dataField: 'interesse',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const distantFuture = new Date(8640000000000000);
        const dateA = a ? new Date(a) : distantFuture;
        const dateB = b ? new Date(b) : distantFuture;

        if (order === 'desc') {
          return dateB - dateA;
        }
        return dateA - dateB;
      },
      formatter: (cell) => {
        return (
          <span className="text-center-block">
            {cell && format(new Date(cell), 'dd/MM/yy HH:mm')}
          </span>
        );
      },
    },
  ];

  const columns = [
    {
      text: 'Fornecedor',
      dataField: 'fornecedor',
      sort: true,
      headerFormatter: renderFornecedorHeader,
      formatter: (cell, row) => {
        return (
          <Tooltip placement="top" title={cell}>
            <span
              onClick={() => {
                reloadPage(row, 'NotasDisponiveis');
                setUpdateInfo({
                  origin: primaryOption,
                  fornecedorId: row?.fornecedorId,
                  canUpdate: false,
                });
              }}
            >
              {cell && cell.length >= 45 ? `${cell.slice(0, 45)}...` : cell}
            </span>
          </Tooltip>
        );
      },
    },
    {
      text: 'Prz',
      dataField: 'prazoMedio',
      className: 'text-right',
      sort: true,
      formatter: (cell) => {
        return <span className="text-right d-block">{cell}</span>;
      },
    },
    {
      text: 'Valor',
      dataField: 'valorBruto',
      sort: true,
      formatter: (cell) => {
        return (
          <span className="text-right d-block">{cell && convertForRealFormatted(cell, 2)}</span>
        );
      },
    },
    {
      text: 'Simulação',
      dataField: 'simulacao',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const distantFuture = new Date(8640000000000000);
        const dateA = a ? new Date(a) : distantFuture;
        const dateB = b ? new Date(b) : distantFuture;

        if (order === 'desc') {
          return dateB - dateA;
        }
        return dateA - dateB;
      },
      formatter: (cell) => {
        return (
          <span className="text-center-block">
            {cell && format(new Date(cell), 'dd/MM/yy HH:mm')}
          </span>
        );
      },
    },
    {
      text: 'Interesse',
      dataField: 'interesse',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const distantFuture = new Date(8640000000000000);
        const dateA = a ? new Date(a) : distantFuture;
        const dateB = b ? new Date(b) : distantFuture;

        if (order === 'desc') {
          return dateB - dateA;
        }
        return dateA - dateB;
      },
      formatter: (cell) => {
        return (
          <span className="text-center-block">
            {cell && format(new Date(cell), 'dd/MM/yy HH:mm')}
          </span>
        );
      },
    },
  ];

  const columnsPesquisar = [
    {
      text: '',
      dataField: 'origem',
      sort: true,
      style: { width: '20px' },
      formatter: (cell) => {
        if(cell == 'Favoritos') {
          return (
            <div style={{ width: '20px' }}>
              <StarIcon style={{ color: '#f0a918', fontSize: '20px'}} />
            </div>
          )
        } else if (cell == 'Agendamento') {
          return (
            <div style={{ width: '20px' }}>
              <CalendarMonthIcon style={{ color: '#1976d2', fontSize: '18px' }} />
            </div>
          )
        } else if (cell == 'Classificados') {
          return (
            <div style={{ width: '20px' }}>
              <FilterAltIcon color="action" style={{ color: '#ff0000', fontSize: '20px' }} />
            </div>
          )
        } else if(cell) {
          return <div style={{ width: '20px' }}></div>
        }
      }
    },
    {
      text: 'Fornecedor',
      dataField: 'fornecedor',
      sort: true,
      headerFormatter: renderFornecedorHeader,
      formatter: (cell, row) => {
        return (
          <Tooltip placement="top" title={cell}>
            <span
              onClick={() => {
                reloadPage(row, 'NotasDisponiveis');
                setUpdateInfo({
                  origin: primaryOption,
                  fornecedorId: row?.fornecedorId,
                  canUpdate: false,
                });
              }}
            >
              {cell && cell.length >= 45 ? `${cell.slice(0, 45)}...` : (cell ? cell : '')}
            </span>
          </Tooltip>
        );
      },
    },
    {
      text: 'CNPJ/CPF',
      dataField: 'cnpjCpf',
      sort: true,
      style: { width: '150px' },
      formatter: (cell) => {
        return <span className="text-left d-block">{cell ? cell : ''}</span>;
      },
    },{
      text: 'Frequência',
      dataField: 'frequenciaAntecipacaoId',
      className: 'text-left',
      sort: true,
      formatter: (cell, rowData) => {
        if(cell == 'NuncaAntecipou') {
          return <span className="text-left d-block">{rowData.corporate === 'Sim' ? 'PROSPECÇÃO *CORPORATE*' : 'PROSPECÇÃO'}</span>;
        } else if (cell == 'MaiorQue90') {
          return <span className="text-left d-block">{rowData.corporate == 'Sim' ? '> 90 *CORPORATE*' : '> 90'}</span>;
        } else if (cell == 'De1a30') {
          return <span className="text-left d-block">{rowData.corporate == 'Sim' ? '1-30 *CORPORATE*' : '1-30'}</span>;
        } else if (cell == 'De31a90') {
          return <span className="text-left d-block">{rowData.corporate == 'Sim' ? '31-90 *CORPORATE*' : '31-90'}</span>;
        } else {
          return <span className="text-left d-block">{rowData.corporate == 'Sim' ? cell+ ' *CORPORATE*' : cell}</span>;
        }
      },
    },
  ];

  const columnsEmails = [
    {
      text: '',
      dataField: 'fornecedorId',
      headerFormatter: () => {
        return (
          <S.IconSend>
            <Tooltip placement="top" title="Enviar e-mail">
              <SendIcon
                disabled={isSending}
                className="pointer"
                onClick={() => handleConfirmationBox('confirmaEmail')}
              />
            </Tooltip>
          </S.IconSend>
        );
      },
      className: 'text-right',
      sort: false,
      formatter: (cell, row) => {
        return (
          <input
            type="checkbox"
            disabled={!row?.liberado}
            onChange={() => {
              if (row?.liberado) {
                handleCheckEmail(cell, row);
              }
            }}
          />
        );
      },
    },
    {
      text: 'Fornecedor',
      dataField: 'fornecedor',
      sort: true,
      headerFormatter: renderFornecedorHeader,
      formatter: (cell, row) => {
        return (
          <Tooltip placement="top" title={cell}>
            <span
              onClick={() => {
                reloadPage(row, 'NotasDisponiveis');
                setUpdateInfo({
                  origin: primaryOption,
                  fornecedorId: row?.fornecedorId,
                  canUpdate: false,
                });
              }}
            >{cell && cell.length >= 35 ? `${cell.slice(0, 35)}...` : cell}</span>
          </Tooltip>
        );
      },
    },
    {
      text: 'Prz',
      dataField: 'prazoMedio',
      className: 'text-right',
      sort: true,
      formatter: (cell) => {
        return <span className="text-right d-block">{cell}</span>;
      },
    },
    {
      text: 'Valor',
      dataField: 'valorBruto',
      sort: true,
      formatter: (cell) => {
        return (
          <span className="text-right d-block">{cell && convertForRealFormatted(cell, 2)}</span>
        );
      },
    },
    {
      text: 'Envio',
      dataField: 'envio',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const distantFuture = new Date(8640000000000000);

        let dateA = distantFuture;
        let dateB = distantFuture;

        if (a.includes('às')) {
          const day = a.split('às')[0].substr(0, 2);
          const month = a.split('às')[0].substr(3, 2);
          let year = a.split('às')[0].substr(6, 2);
          if (year < new Date().getFullYear()) {
            year = 2000 + Number(year);
          }

          dateA = new Date(`${year}/${month}/${day} ${a.split('às')[1]}`);
        } else if (a === '') {
          dateA = new Date(0);
        }

        if (b.includes('às')) {
          const day = b.split('às')[0].substr(0, 2);
          const month = b.split('às')[0].substr(3, 2);
          let year = b.split('às')[0].substr(6, 2);
          if (year < new Date().getFullYear()) {
            year = 2000 + Number(year);
          }

          dateB = new Date(`${year}/${month}/${day} ${b.split('às')[1]}`);
        } else if (b === '') {
          dateB = new Date(0);
        }

        if (order === 'desc') {
          return dateB - dateA;
        }
        return dateA - dateB;
      },
      formatter: (cell) => {
        return (
          <Tooltip placement="top" title={cell}>
            <span>{cell && cell.length >= 18 ? `${cell.slice(0, 18)}...` : cell.replace('às ', '')}</span>
          </Tooltip>
        );
      },
    },
    {
      text: 'Resp',
      dataField: 'conclusao',
      sort: true,
      className: "text-center-block",
      formatter: (cell) => {
        switch (cell) {
          case 1:
            return (
              <div className='text-center-block'>
                <EmailIcon  style={{ color: '#689f38', fontSize: '20px' }}/>
              </div>
            )
          case 2:
            return (
              <div className='text-center-block'>
                <EmailIcon style={{ color: '#ff0000', fontSize: '20px' }}/>
              </div>
            )
          default:
            return ''
        };
      },
    },
    {
      text: 'Simulação',
      dataField: 'simulacao',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const distantFuture = new Date(8640000000000000);
        const dateA = a ? new Date(a) : distantFuture;
        const dateB = b ? new Date(b) : distantFuture;
        if (order === 'desc') {
          return dateB - dateA;
        }
        return dateA - dateB;
      },
      formatter: (cell) => {
        return (
          <span className="text-left-block">
            {cell && format(new Date(cell), 'dd/MM/yy HH:mm')}
          </span>
        );
      },
    },    
  ];

  const columnsProposes = [
    {
      text: 'Data',
      dataField: 'dataBase',
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        if (order === 'asc') {
          return Date.parse(a) - Date.parse(b);
        } else if (order === 'desc') {
          return Date.parse(b) - Date.parse(a);
        }
      },
      formatter: (cell) => {
        return (
          <span className="text-center-block">{cell && format(new Date(cell), 'dd/MM/yy')}</span>
        );
      },
    },
    {
      text: 'Pagto',
      dataField: 'destinoPagamento',
      sort: true,
      formatter: (cell) => {
        return <span className="text-center d-block">{cell}</span>;
      },
    },
    {
      text: 'Fornecedor',
      dataField: 'razaoSocial',
      sort: true,
      headerFormatter: renderFornecedorHeader,
      formatter: (cell, row) => {
        return (
          <Tooltip placement="top" title={cell}>
            <span
              onClick={() => {
                reloadPage(row, 'HistoricoConsultaPesquisa');
                setUpdateInfo({
                  origin: primaryOption,
                  id: row?.fornecedorId,
                  canUpdate: false,
                });
              }}
            >
              {cell && cell.length >= 45 ? `${cell.slice(0, 45)}...` : cell}
            </span>
          </Tooltip>
        );
      },
    },
    {
      text: 'Documento',
      dataField: 'cnpjCpf',
      className: 'text-right',
      sort: true,
      formatter: (cell) => {
        return <span className="text-right d-block">{cell}</span>;
      },
    },
    {
      text: 'Valor',
      dataField: 'valorLiquido',
      sort: true,
      formatter: (cell) => {
        return (
          <span className="text-right d-block">{cell && convertForRealFormatted(cell, 2)}</span>
        );
      },
    },
    {
      text: 'Status',
      dataField: 'status',
      sort: true,
      formatter: (cell, rowData) => {
        return (
  <span className="">{`${
    cell === 'Pendente' && rowData.situacao === 'Substituida'       ? 'Substituida' .toUpperCase()
      : cell === 'Pendente' && rowData.situacao === 'Vencida'       ? 'Vencida' .toUpperCase()
      : cell.toUpperCase()
  }`}</span>
);
      },
    },
  ];

  const handleClickAgendamentos = (row) => {
    reloadPage(row, 'Agendamentos');
    setUpdateInfo({
      origin: primaryOption,
      id: row?.fornecedorId,
      canUpdate: false,
    });
  }

  const fetchAvailableNotes = async (date = '', frequency = secondOptionButton) => {
    setReloadRightTable(false);
    setProviders([]);
    let endpoint;
    if (date !== '') {
      endpoint = `OperacoesAntecipacoes/ConsultarNotasDisponiveis?ancoraId=${anchorId}&frequenciaAntecipacao=${frequency}&dataAgendamento=${
        (frequency === 'Agendado' && date) || format(new Date(), 'dd-MM-yyyy')
      }`;
    } else {
      endpoint = `OperacoesAntecipacoes/ConsultarNotasDisponiveis?ancoraId=${anchorId}&frequenciaAntecipacao=${frequency}&dataAgendamento=`;
    }
    setIsLoading(true);
    try {
      const response = await api.get(endpoint);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        setProviders(response.data.resposta);
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      setMessageData(error?.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
    setIsLoading(false);
  };

  const fetchProposes = async () => {
    setIsLoading(true);
    try {
      let destinoPagamentoId = proposesSearch?.destinoPagamentoId || (Number(sessionStorage.getItem("DestinoPagamentoIdAtual")) || 1);
      const endPoint = `OperacoesAntecipacoes/ConsultarAntecipacoesPesquisaGrid?ancoraId=${anchorId}&fornecedorId=${
        proposesSearch?.fornecedorId
      }&paginaInicial=0&itensPorPagina=0&dataInicial=${format(
        proposesSearch.dataInicial,
        'yyyy-MM-dd',
      )}&dataFinal=${format(proposesSearch.dataFinal, 'yyyy-MM-dd')}&razaoSocial=${
        proposesSearch?.razaoSocial
        }&cnpjCpf=${proposesSearch?.cnpjCpf}&Status=${proposesSearch?.status}&destinoPagamentoId=${destinoPagamentoId}`;
      const response = await api.get(endPoint);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        setProposesSearchResult(response.data.resposta);
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      setMessageData(error?.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
    setIsLoading(false);
  };

  const fetchSchedules = async () => {
    setIsLoading(true);
    try {
      const endPoint = `OperacoesAntecipacoes/ConsultarFornecedoresAnotacoesGrid?paginaInicial=0&itensPorPagina=0&fornecedorId=${
        schedulesSearch.fornecedorId
      }&ancoraId=${anchorId}&dataInicial=${format(
        schedulesSearch.dataInicial,
        'yyyy-MM-dd',
      )}&dataFinal=${format(schedulesSearch.dataFinal, 'yyyy-MM-dd')}&Fornecedor=${
        schedulesSearch.razaoSocial
      }&cnpjCpf=${schedulesSearch.cnpjCpf}`;
      const response = await api.get(endPoint);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        if (response.data.resposta[0].message !== NO_DATA_MESSAGE) {
          setScheduleSearchResult(response.data.resposta);
        } else {
          setScheduleSearchResult([]);
        }
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      setMessageData(error?.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
    setIsLoading(false);
  };

  const handlePrimaryButton = (option) => {
    setFornecedorSearchText('');
    setPrimaryOption(option);
    if (option === 'notas-disponiveis') {
      fetchAvailableNotes(format(new Date(), 'yyyy-MM-dd'), 'Agendado');
      setSecondOptionButton('Agendado');
    } else if (option === 'pesquisar') {
      fetchAvailableNotes(format(new Date(), 'yyyy-MM-dd'), 'TODOS');
    } else if (option ===  'agendamentos') {
      fetchSchedules()
    }
  };

  const handleSecondButton = (option) => {
    setFornecedorSearchText('');
    setSecondOptionButton(option);
    if (option === 'Agendado') {
      return fetchAvailableNotes(format(new Date(), 'yyyy-MM-dd'), option);
    }
    if (option === 'emailInteresse') {
      return fetchEmails(anchorId);
    }
    fetchAvailableNotes('', option);
  };

  const renderButtonsOption = () => {
    switch (primaryOption) {
      case 'notas-disponiveis':
        return (
          <S.FilterOptions>
            <Button
              className="btn-text"
              style={{
                background:
                  secondOptionButton === 'NuncaAntecipou' ? colors.sanMarino : 'transparent',
                color: secondOptionButton === 'NuncaAntecipou' ? '#fff' : '#000',
              }}
              disableElevation
              variant={secondOptionButton === 'NuncaAntecipou' ? 'contained' : 'outlined'}
              onClick={() => handleSecondButton('NuncaAntecipou')}
              color="primary"
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>Prospecção</span>
                <span style={{ textAlign: 'center' }}>{opcoesButtons.nuncaAntecipouQuantidade}</span>
              </div>
            </Button>
            <Button
              className="btn-text"
              style={{
                background: secondOptionButton === 'Agendado' ? colors.sanMarino : 'transparent',
                color: secondOptionButton === 'Agendado' ? '#fff' : '#000',
              }}
              disableElevation
              variant={secondOptionButton === 'Agendado' ? 'contained' : 'outlined'}
              onClick={() => handleSecondButton('Agendado')}
              color="primary"
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>Lista Diária</span>
                <span style={{ textAlign: 'center' }}>{opcoesButtons.agendadoQuantidade}</span>
              </div>
            </Button>
            <Button
              className="btn-text"
              style={{
                background: secondOptionButton === 'De1a30' ? colors.sanMarino : 'transparent',
                color: secondOptionButton === 'De1a30' ? '#fff' : '#000',
              }}
              disableElevation
              variant={secondOptionButton === 'De1a30' ? 'contained' : 'outlined'}
              onClick={() => handleSecondButton('De1a30')}
              color="primary"
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ whiteSpace: 'nowrap' }}>1-30</span>
                <span style={{ textAlign: 'center' }}>{opcoesButtons.de1a30Quantidade}</span>
              </div>
            </Button>
            <Button
              className="btn-text"
              style={{
                background: secondOptionButton === 'De31a90' ? colors.sanMarino : 'transparent',
                color: secondOptionButton === 'De31a90' ? '#fff' : '#000',
              }}
              disableElevation
              variant={secondOptionButton === 'De31a90' ? 'contained' : 'outlined'}
              onClick={() => handleSecondButton('De31a90')}
              color="primary"
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ whiteSpace: 'nowrap' }}>31-90</span>
                <span style={{ textAlign: 'center' }}>{opcoesButtons.de31a90Quantidade}</span>
              </div>
            </Button>
            <Button
              className="btn-text"
              style={{
                background: secondOptionButton === 'Maior90' ? colors.sanMarino : 'transparent',
                color: secondOptionButton === 'Maior90' ? '#fff' : '#000',
              }}
              disableElevation
              variant={secondOptionButton === 'Maior90' ? 'contained' : 'outlined'}
              onClick={() => handleSecondButton('Maior90')}
              color="primary"
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ whiteSpace: 'nowrap' }}>&gt; 90</span>
                <span style={{ textAlign: 'center' }}>{opcoesButtons.maior90Quantidade}</span>
              </div>
            </Button>
            {selectedAnchor && selectedAnchor?.controlaCorporate == 1 && (
              <Button
                className="btn-text"
                style={{
                  background: secondOptionButton === 'Corporate' ? colors.sanMarino : 'transparent',
                  color: secondOptionButton === 'Corporate' ? '#fff' : '#000',
                }}
                disableElevation
                variant={secondOptionButton === 'Corporate' ? 'contained' : 'outlined'}
                onClick={() => handleSecondButton('Corporate')}
                color="primary"
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ whiteSpace: 'nowrap' }}>Corporate</span>
                  <span style={{ textAlign: 'center' }}>{opcoesButtons.corporateQuantidade}</span>
                </div>
              </Button>
            )}
            <Button
              className="btn-text"
              style={{
                background:
                  secondOptionButton === 'emailInteresse' ? colors.sanMarino : 'transparent',
                color: secondOptionButton === 'emailInteresse' ? '#fff' : '#000',
              }}
              disableElevation
              variant={secondOptionButton === 'emailInteresse' ? 'contained' : 'outlined'}
              onClick={() => handleSecondButton('emailInteresse')}
              color="primary"
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>Emails interesse</span>
                <span style={{ textAlign: 'center' }}>{opcoesButtons.interesseQuantidade}</span>
              </div>
            </Button>
          </S.FilterOptions>
        );

      case 'propostas':
        return (
          <S.FilterOptions>
            <S.InputOptions>
              <div className="input-column">
                <Input
                  placeholder="ID Forn."
                  value={proposesSearch?.fornecedorId}
                  onChange={(e) => {
                    const re = /^[-.0-9\b]+$/;
                    if (e.target.value === '' || re.test(e.target.value)) {
                      setProposesSearch({ ...proposesSearch, fornecedorId: e.target.value });
                    }
                  }}
                  className="w-50"
                  inputProps={{
                    maxLength: 18,
                  }}
                />
                <Input
                  className="w-50"
                  placeholder="CNPJ/CPF"
                  value={proposesSearch?.cnpjCpf}
                  onChange={(e) => {
                    const re = /^[-/\.0-9\b]+$/;
                    if (e.target.value === '' || re.test(e.target.value)) {
                      setProposesSearch({ ...proposesSearch, cnpjCpf: e.target.value });
                    }
                  }}
                  inputProps={{
                    maxLength: 18,
                  }}
                />
                <Input
                  placeholder="Nome Forn."
                  value={proposesSearch?.razaoSocial}
                  onChange={(e) =>
                    setProposesSearch({ ...proposesSearch, razaoSocial: e.target.value })
                  }
                  inputProps={{
                    maxLength: 18,
                  }}
                  className="w-100 toUppercase"
                />
              </div>
              <div className="input-column">
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <DatePicker
                    selected={proposesSearch?.dataInicial}
                    onChange={(e) => setProposesSearch({ ...proposesSearch, dataInicial: e })}
                    dateFormat="dd/MM/yyyy"
                    locale="ptBR"
                  />

                  <DatePicker
                    selected={proposesSearch?.dataFinal}
                    className="last-date"
                    onChange={(e) => setProposesSearch({ ...proposesSearch, dataFinal: e })}
                    dateFormat="dd/MM/yyyy"
                    locale="ptBR"
                  />
                </div>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                >
                  <NativeSelect
                    className="w-50"
                    style={{ width: '48%' }}
                    value={proposesSearch?.destinoPagamentoId}
                    onChange={(e) => setProposesSearch({ ...proposesSearch, destinoPagamentoId: e.target.value })}
                  >
                    <option value="0">Consolidado</option>
                    {destinoOpcoes.map((destino) => (
                      <option key={destino.destinoPagamentoId} value={destino.destinoPagamentoId.toString()}>
                        {capitalizeFirstLetter(destino.destinoPagamento)}
                      </option>
                    ))}
                  </NativeSelect>
                  <NativeSelect
                    className="w-50"
                    style={{ width: '48%' }}
                    value={proposesSearch?.status}
                    onChange={(e) => setProposesSearch({ ...proposesSearch, status: e.target.value })}
                  >
                    <option value="">Todos</option>
                    <option value="Pendente">Pend/Subst/Venc</option>
                    <option value="Aprovada">Aprovada</option>
                    <option value="Recusada">Recusada</option>
                    <option value="Cancelada">Cancelada</option>
                  </NativeSelect>
                </div>
                
              </div>
            </S.InputOptions>
            <div className="btn-search-actions">
              <Button
                className="btn-text search-btn"
                disableElevation
                color="primary"
                onClick={() => {
                  setProposesSearchResult([]);
                  setProposesSearch({
                    dataInicial: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                    dataFinal: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
                    razaoSocial: '',
                    cnpjCpf: '',
                    fornecedorId: '',
                    status: '',
                    destinoPagamentoId: '0'
                  });
                }}
                style={{ background: colors.gold, color: '#fff' }}
              >
                Limpar
              </Button>
              <Button
                className="btn-text search-btn"
                disableElevation
                color="primary"
                onClick={() => fetchProposes()}
                style={{ background: colors.sanMarino, color: '#fff' }}
              >
                Pesquisar
              </Button>
            </div>
          </S.FilterOptions>
        );
        case 'pesquisar':
          return (
            <S.FilterOptions>
              <S.InputOptions>
                <Input
                  placeholder="Nome Forn."
                  value={pesquisarSearch?.razaoSocial}
                  onChange={(e) =>{
                    setPesquisarSearch({ ...pesquisarSearch, razaoSocial: e.target.value.toUpperCase() })
                  }}
                  inputProps={{
                    maxLength: 18,
                  }}
                  className="w-100 toUppercase"
                />
                <Input
                  className="w-50"
                  style={{ width: '70%' }}
                  placeholder="CNPJ/CPF"
                  value={pesquisarSearch?.cnpjCpf}
                  onChange={(e) => {
                    const re = /^[-/\.0-9\b]+$/;
                    if (e.target.value === '' || re.test(e.target.value)) {
                      setPesquisarSearch({ ...pesquisarSearch, cnpjCpf: e.target.value });
                    }
                  }}
                  inputProps={{
                    maxLength: 18,
                  }}
                />
              </S.InputOptions>
              <div className="btn-search-actions" style={{ bottom: 0 }}>
                <Button
                  className="btn-text search-btn"
                  disableElevation
                  color="primary"
                  onClick={() => {
                    setPesquisarSearch({
                      razaoSocial: '',
                      cnpjCpf: '',
                    })
                  }}
                  style={{ background: colors.gold, color: '#fff' }}
                >
                  Limpar
                </Button>
              </div>
            </S.FilterOptions>
          );

      case 'agendamentos':
        return (
          <S.FilterOptions>
            <S.InputOptions>
              <div className="input-column">
                <Input
                  placeholder="ID Forn."
                  value={schedulesSearch?.fornecedorId}
                  onChange={(e) => {
                    const re = /^[-.0-9\b]+$/;
                    if (e.target.value === '' || re.test(e.target.value)) {
                      setSchedulesSearch({ ...schedulesSearch, fornecedorId: e.target.value });
                    }
                  }}
                  className="w-50"
                  inputProps={{
                    maxLength: 18,
                  }}
                />
                <Input
                  className="w-50"
                  placeholder="CNPJ/CPF"
                  value={schedulesSearch?.cnpjCpf}
                  onChange={(e) => {
                    const re = /^[-/\.0-9\b]+$/;
                    if (e.target.value === '' || re.test(e.target.value)) {
                      setSchedulesSearch({ ...schedulesSearch, cnpjCpf: e.target.value });
                    }
                  }}
                  inputProps={{
                    maxLength: 18,
                  }}
                />
                <Input
                  placeholder="Nome Forn."
                  value={schedulesSearch?.razaoSocial}
                  onChange={(e) =>
                    setSchedulesSearch({ ...schedulesSearch, razaoSocial: e.target.value })
                  }
                  inputProps={{
                    maxLength: 18,
                  }}
                  className="w-100 toUppercase"
                />
              </div>
              <div className="input-column">
                <DatePicker
                  selected={schedulesSearch?.dataInicial}
                  onChange={(e) => setSchedulesSearch({ ...schedulesSearch, dataInicial: e })}
                  dateFormat="dd/MM/yyyy"
                  locale="ptBR"
                />
                <DatePicker
                  selected={schedulesSearch?.dataFinal}
                  className="last-date"
                  onChange={(e) => setSchedulesSearch({ ...schedulesSearch, dataFinal: e })}
                  dateFormat="dd/MM/yyyy"
                  locale="ptBR"
                />
              </div>
            </S.InputOptions>
            <div className="btn-search-actions">
              <Button
                className="btn-text search-btn"
                disableElevation
                color="primary"
                onClick={() => {
                  setScheduleSearchResult([]);
                  setSchedulesSearch({
                    dataInicial: new Date(),
                    dataFinal: addDays(new Date(), 30),
                    razaoSocial: '',
                    cnpjCpf: '',
                    fornecedorId: '',
                  });
                }}
                style={{ background: colors.gold, color: '#fff' }}
              >
                Limpar
              </Button>
              <Button
                className="btn-text search-btn"
                disableElevation
                color="primary"
                onClick={() => fetchSchedules()}
                style={{ background: colors.sanMarino, color: '#fff' }}
              >
                Pesquisar
              </Button>
            </div>
          </S.FilterOptions>
        );
      default:
        break;
    }
  };

  const fetchDestinoPagamentos = async () => {
    try {
      const destinos = await api.get('DestinosPagamentos/Consultar?status=Ativo')
      if(destinos && destinos.data && destinos.data.status == 'Sucesso') {
        setDestinoOpcoes(destinos.data.resposta)
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
  }

  const fetchOpcoesButtons = async () => {
    try {
      const result = await api.get(`OperacoesAntecipacoes/ConsultarQuantidadeNotasDisponiveisTotalizadoPorFrequenciasAntecipacoesAncoras?ancoraId=${anchorId}`)
      if(result && result.data && result.data.status == 'Sucesso') {
        setOpcoesButtons({
          nuncaAntecipouQuantidade: result.data.resposta.nuncaAntecipouQuantidade,
          agendadoQuantidade: result.data.resposta.agendadoQuantidade,
          de1a30Quantidade: result.data.resposta.de1a30Quantidade,
          de31a90Quantidade: result.data.resposta.de31a90Quantidade,
          maior90Quantidade: result.data.resposta.maior90Quantidade,
          interesseQuantidade: result.data.resposta.interesseQuantidade,
          corporateQuantidade: result.data.resposta.corporateQuantidade,
        });
      }
    } catch (err) {
      setOpcoesButtons({
        nuncaAntecipouQuantidade: '',
        agendadoQuantidade: '',
        de1a30Quantidade: '',
        de31a90Quantidade: '',
        maior90Quantidade: '',
        interesseQuantidade: '',
        corporateQuantidade: '',
      });
      console.log(err);
    }
  }

  useEffect(() => {
    const initialize = async () => {
      setIsLoading(true);
      await fetchDestinoPagamentos();
      setIsLoading(false);
    };
    initialize();
  }, []);

  useEffect(() => {
    const initialize = async () => {
      setIsLoading(true);
      await fetchAvailableNotes(format(new Date(), 'yyyy-MM-dd'), 'Agendado');
      await fetchOpcoesButtons();
      setIsLoading(false);
    };
    if (anchorId) {
      setPrimaryOption('notas-disponiveis');
      setSecondOptionButton('Agendado');
      initialize();
    }
  }, [anchorId]);

  useEffect(() => {
    const initialize = async () => {
      setIsLoading(true);
      await fetchAvailableNotes(format(new Date(), 'yyyy-MM-dd'))
      setIsLoading(false);
    };
    if (reloadRightTable) {
      initialize();
    }
  }, [reloadRightTable])

  useEffect(() => {
    if (Object.keys(updateRightTable).length > 0) {
      const options = providers;
      const providerToUpdate = providers.findIndex(
        (el) => el.fornecedorId === updateRightTable.fornecedorId,
      );
      const newValue = {
        ...providers[providerToUpdate],
        valorBruto: updateRightTable.valorBruto,
      };
      options.splice(providerToUpdate, 1);
      options.splice(providerToUpdate, 0, newValue);
      setProviders(options);
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  }, [updateRightTable]);

  useEffect(() => {
    if (updateInfo.canUpdate) {
      if (updateInfo.origin === 'notas-disponiveis' || updateInfo.origin === 'pesquisar') {
        const options = providers;
        const newOptions = options.filter((item) => item.fornecedorId !== updateInfo.fornecedorId);
        setProviders(newOptions);
        setTimeout(() => {
          setUpdateInfo({ origin: '', id: null, canUpdate: false });
        }, 100);
      }
    }
  }, [updateInfo]);

  const handleSearchPesquisar = () => {
    let listSearched = []
    if(providers.length > 0) {
      listSearched = providers.slice();
      if(pesquisarSearch.razaoSocial) {
        listSearched = listSearched.filter((x) => {
          if(x.fornecedor) {
            return x.fornecedor.includes(pesquisarSearch.razaoSocial)
          } else {
            return null
          }
        })
      }
  
      if(pesquisarSearch.cnpjCpf) {
        listSearched = listSearched.filter((x) => {
          if(x.cnpjCpf) {
            let cpfCnpj = x.cnpjCpf.replace(/[^0-9]/g, "")
            return cpfCnpj.includes(pesquisarSearch.cnpjCpf.replace(/[^0-9]/g, ""))
          } else {
            return null
          }
        })
      }
    }
    return listSearched
  }

  const rowStyle = (row) => {
    const style = {}

    if(row.corFonte) {
      style.color = row.corFonte
    }

    if (row.corFundo) {
      style.backgroundColor = row.corFundo
    }

    return style
  }

  const filterRowsByFornecedor = (rows = [], field = 'fornecedor') => {
    const searchValue = normalizeSearchText(fornecedorSearchText);

    if (!searchValue) {
      return rows;
    }

    return rows.filter((item) => normalizeSearchText(item?.[field]).includes(searchValue));
  }

  return (
    <S.RightContainer>
      <S.ActionsButtons>
        <S.ButtonsContainer>
          <Button
            style={{
              background: primaryOption === 'notas-disponiveis' ? colors.sanMarino : 'transparent',
              color: primaryOption === 'notas-disponiveis' ? '#fff' : '#000',
            }}
            variant={primaryOption === 'notas-disponiveis' ? 'contained' : 'outlined'}
            onClick={() => {
              setPesquisarSearch({ razaoSocial: '',cnpjCpf: '' })
              setFornecedorSearchText('');
              handlePrimaryButton('notas-disponiveis');
              setSchedulesSearch({
                dataInicial: new Date(),
                dataFinal: new Date(),
                razaoSocial: '',
                cnpjCpf: '',
                fornecedorId: '',
              });
              setProposesSearch({
                dataInicial: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                dataFinal: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
                razaoSocial: '',
                cnpjCpf: '',
                fornecedorId: '',
                status: '',
                destinoPagamentoId: '0'
              });
              setProposesSearchResult([]);
              setScheduleSearchResult([]);
            }}
            disableElevation
            className="btn-text"
          >
            Notas disponíveis
          </Button>
          <Button
            style={{
              background: primaryOption === 'pesquisar' ? colors.sanMarino : 'transparent',
              color: primaryOption === 'pesquisar' ? '#fff' : '#000',
            }}
            variant={primaryOption === 'pesquisar' ? 'contained' : 'outlined'}
            onClick={() => {
              setPesquisarSearch({ razaoSocial: '',cnpjCpf: '' })
              setFornecedorSearchText('');
              handlePrimaryButton('pesquisar');
              setSchedulesSearch({
                dataInicial: new Date(),
                dataFinal: new Date(),
                razaoSocial: '',
                cnpjCpf: '',
                fornecedorId: '',
              });
              setProposesSearch({
                dataInicial: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                dataFinal: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
                razaoSocial: '',
                cnpjCpf: '',
                fornecedorId: '',
                status: '',
                destinoPagamentoId: '0'
              });
              setProposesSearchResult([]);
              setScheduleSearchResult([]);
            }}
            disableElevation
            className="btn-text"
          >
            Pesquisar
          </Button>
          <Button
            variant={primaryOption === 'propostas' ? 'contained' : 'outlined'}
            style={{
              background: primaryOption === 'propostas' ? colors.sanMarino : 'transparent',
              color: primaryOption === 'propostas' ? '#fff' : '#000',
            }}
            onClick={() => {
              setPesquisarSearch({ razaoSocial: '',cnpjCpf: '' })
              setFornecedorSearchText('');
              handlePrimaryButton('propostas');
              setProviders([]);
              setScheduleSearchResult([]);
              setSchedulesSearch({
                dataInicial: new Date(),
                dataFinal: new Date(),
                razaoSocial: '',
                cnpjCpf: '',
                fornecedorId: '',
              });
            }}
            disableElevation
            className="btn-text"
          >
            Pesquisar propostas
          </Button>
          <Button
            variant={primaryOption === 'agendamentos' ? 'contained' : 'outlined'}
            style={{
              background: isTimer ? agendamentosBackground : (primaryOption === 'agendamentos' ? colors.sanMarino : 'transparent'),
              color: isTimer ? '#fff' : (primaryOption === 'agendamentos' ? '#fff' : '#000'),
            }}
            onClick={() => {
              setProposesSearch({
                dataInicial: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                dataFinal: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
                razaoSocial: '',
                cnpjCpf: '',
                fornecedorId: '',
                status: '',
                destinoPagamentoId: '0'
              });
              setSchedulesSearch({
                dataInicial: new Date(),
                dataFinal: new Date(),
                razaoSocial: '',
                cnpjCpf: '',
                fornecedorId: '',
              });
              setPesquisarSearch({ razaoSocial: '',cnpjCpf: '' })
              setFornecedorSearchText('');
              handlePrimaryButton('agendamentos');
              setProviders([]);
              setProposesSearchResult([]);
            }}
            disableElevation
            id="btn-agendamento"
            className="btn-text"
          >
            Pesquisar agendamentos
          </Button>
          <Tooltip placement="top" title="Recarregar conteúdo">
            <CachedIcon
              className="pointer"
              onClick={async () => {
                setIsLoading(true);
                setOpcoesButtons({
                  nuncaAntecipouQuantidade: '',
                  agendadoQuantidade: '',
                  de1a30Quantidade: '',
                  de31a90Quantidade: '',
                  maior90Quantidade: '',
                  interesseQuantidade: '',
                  corporateQuantidade: ''
                });
                if (
                  primaryOption === 'notas-disponiveis' &&
                  secondOptionButton === 'emailInteresse'
                ) {
                  return fetchEmails(anchorId);
                }
                if (primaryOption === 'notas-disponiveis' && secondOptionButton !== 'Agendado') {
                  return fetchAvailableNotes();
                }
                if (primaryOption === 'propostas') {
                  return fetchProposes();
                }
                if (primaryOption === 'agendamentos') {
                  return fetchSchedules();
                } else {
                  fetchAvailableNotes(format(new Date(), 'yyyy-MM-dd'));
                }
                await fetchOpcoesButtons();
                setIsLoading(false);
              }}
            />
          </Tooltip>
        </S.ButtonsContainer>
        {renderButtonsOption()}
      </S.ActionsButtons>
      {isLoading || isSending ? (
        <Loading />
      ) : (
        <>
          {primaryOption === 'pesquisar' && (
            <S.MiddleTable className="search-proposes">
              <BootstrapTable
                columns={columnsPesquisar}
                condensed
                data={handleSearchPesquisar()}
                hover
                keyField="id"
                striped
                rowStyle={rowStyle}
              />
            </S.MiddleTable>
          )}
          {primaryOption === 'notas-disponiveis' &&
            providers &&
            secondOptionButton !== 'emailInteresse' &&
            secondOptionButton !== 'Agendado' && (
              <S.MiddleTable className="available-notes">
                <BootstrapTable
                  columns={columns}
                  condensed
                  data={filterRowsByFornecedor(providers)}
                  hover
                  keyField="id"
                  striped
                  rowStyle={rowStyle}
                />
              </S.MiddleTable>
            )}

            {primaryOption === 'notas-disponiveis' &&
              providers && secondOptionButton === 'Agendado' && (
              <S.MiddleTable className="agendado">
                <BootstrapTable
                  columns={columnsAgendado}
                  condensed
                  data={filterRowsByFornecedor(providers)}
                  hover
                  keyField="id"
                  striped
                  rowStyle={rowStyle}
                />
              </S.MiddleTable>
            )}

          {primaryOption === 'notas-disponiveis' && secondOptionButton === 'emailInteresse' && (
            <S.MiddleTable className="email-table">
              {emailsData && (
                <BootstrapTable
                  columns={columnsEmails}
                  condensed
                  data={filterRowsByFornecedor(emailsData)}
                  hover
                  keyField="id"
                  striped
                  rowStyle={rowStyle}
                />
              )}
            </S.MiddleTable>
          )}

          {primaryOption === 'propostas' && (
            <S.MiddleTable withoutFirstWidth className="proposes">
              <S.TableTitleHeader>
                <h3 className="operation-title">Resultado da pesquisa das propostas</h3>
              </S.TableTitleHeader>
              {proposesSearchResult.antecipacoes && (
                <BootstrapTable
                  columns={columnsProposes}
                  condensed
                  data={filterRowsByFornecedor(proposesSearchResult?.antecipacoes, 'razaoSocial')}
                  hover
                  keyField="id"
                  striped
                  rowStyle={rowStyle}
                />
              )}
            </S.MiddleTable>
          )}

          {primaryOption === 'agendamentos' && (
            <S.MiddleTable withoutFirstWidth>
              <ScheduledTable data={scheduleSearchResult} clickProvider={handleClickAgendamentos}/>
            </S.MiddleTable>
          )}
        </>
      )}
      {confirmationBox.show && (
        <ConfirmationBox
          data={confirmationBox}
          setConfirmationBox={setConfirmationBox}
        ></ConfirmationBox>
      )}
    </S.RightContainer>
  );
}

export default AnticipationMiddleContent;
